// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_21Rdb9alxd9uMmfurAvclF","notification":"_2quDDkw24uXzkld_BWfk_u","iconWrapper":"_2BBhilHsJRAoGY01pemj50","title":"Vn2RbgDEP5FiFPmBxywro","link":"_6WJkQ-OzdyF_Aiff4lpA-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationNoCompany/NotificationNoCompany.scss
// module id = 1641
// module chunks = 0